import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
//Components
import ModalCustomized from '../../../../components/Modal/Modal';
import TextField from 'components/TextField/TextField';
//Api
import ManutencaoOrdemColeta_api from '../../../../api/ManutencaoOrdemColeta_api';
import rotaColeta_api from '../../../../api/rotaColeta_api';
import gerador_api from '../../../../api/gerador_api';
import volumetria_api from '../../../../api/volumetria_api';
import cep_api from '../../../../api/cep_api';
//Helpers
import mascaras from '../../../../helpers/mascaras';
import { validarCampos, objCampo } from '../../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../../helpers/message';
//Estado initial para a coleta extraordinaria
function initialStateColetaExtraordinaria(id = "") {
    return {
        tbOrdemColeta_Id: id.toString(),
        tbGerador_Id: "",
        identificacao: "",
        tbTipoColeta_Id: "",
        tbVolumetria_Id: "",
        cep: "",
        logradouro: "",
        numero: "",
        complemento: "",
        bairro: "",
        cidade: "",
        uf: "",
        latitude: "",
        longitude: "",
    }
}
export default function ColetaExtraordinaria({ openModal, toggleModal, ordem, setOrdem, setLoading }) {

    //Armazena os dados do select de modalidades de coleta extraoridinaria
    const [modalidades, setModalidades] = useState([]);
    //Armazena os dados do select de geradores de coleta extraoridinaria
    const [geradores, setGeradores] = useState([]);
    //Armazena os dados do select de unidade de medida de coleta extraordinaria
    const [volumetrias, setVolumetrias] = useState([]);
    //Guarda os erros dos campos que não foram preenchidos corretamente
    const [errors, setErrors] = useState({});
    //Estado de controle da coleta extraordinaria
    const [coletaExtra, setColetaExtra] = useState(initialStateColetaExtraordinaria(ordem.id));
    //Campos da coleta extraodinaria que são obrigatorios
    const camposColetaExtra = [
        objCampo({ name: "tbOrdemColeta_Id", required: true }),
        objCampo({ name: "tbGeradorSelected", required: true }),
        objCampo({ name: "identificacao", required: true }),
        objCampo({ name: "tbTipoColeta_Id", required: true }),
        objCampo({ name: "tbVolumetria_Id", required: true }),
        objCampo({ name: "cep", required: true }),
        objCampo({ name: "logradouro", required: true }),
        objCampo({ name: "numero", required: true }),
        objCampo({ name: "bairro", required: true }),
        objCampo({ name: "cidade", required: true }),
        objCampo({ name: "uf", required: true }),
    ]
    //Ação realizada para adicionar uma coleta extraordinaria
    const adicionarColetaExtraordinaria = () => {
        const _errors = validarCampos(coletaExtra, camposColetaExtra);
        if (_errors[1].length > 0) {
            setErrors(_errors[0]);
            return;
        }
        setLoading(true);
        const _coletaExtra = { ...coletaExtra };
        ManutencaoOrdemColeta_api.AdicionaEnderecoExtraordinario(_coletaExtra).then(response => {
            setOrdem({ ...ordem, items: [...ordem.items, response.data] });
            showMessage("Sucesso", "Sucesso ao adicionar a coleta extraordinária", "success", () => setColetaExtra(initialStateColetaExtraordinaria(ordem.id)));
            toggleModal();
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }
    //OnChange para os campos de texto da coleta extraordinaria
    const onChangeColetaExtra = (e) => {
        const { name, value } = e.target;
        const _coletaExtra = {
            ...coletaExtra,
            [name]: value
        }
        const campo = camposColetaExtra.filter(value => value.name === name);
        const _errors = validarCampos(_coletaExtra, campo);
        if (_errors[1].length > 0) {
            setErrors({ ...errors, ..._errors[0] });
        } else {
            const newErrors = { ...errors };
            delete newErrors[name];
            setErrors(newErrors);
        }
        setColetaExtra(_coletaExtra);
    }
    //OnChange para o campo de modalidade da coleta extraordinaria
    const onChangeModalidade = (e) => {
        const { name, value } = e.target;
        const _coletaExtra = {
            ...coletaExtra,
            [name]: value,
            tbVolumetria_Id: ""
        }
        const campo = camposColetaExtra.filter(value => value.name === name);
        const _errors = validarCampos(_coletaExtra, campo);
        if (_errors[1].length > 0) {
            setErrors({ ...errors, ..._errors[0] });
        } else {
            const newErrors = { ...errors };
            delete newErrors[name];
            setErrors(newErrors);
        }
        setColetaExtra(_coletaExtra)
        if (value != "") {
            volumetria_api.GetListByModalidade(value).then(response => {
                const options = response.data.map(value => { return { value: value.id, text: value.tbVolumetria_Descricao } });

                setVolumetrias([{ text: "Selecione", value: "" }, ...options]);
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
            })

        }
    }
    //OnBlur para o campo de cep do endereço
    const onBlurCep = (e) => {
        const { name, value } = e.target;
        const _endereco = {
            ...coletaExtra,
            [name]: value
        }
        _endereco.cep = mascaras.cepMask(_endereco.cep, true);
        if (_endereco.cep.length == 8) {
            cep_api.get(_endereco.cep).then(response => {
                if (response.data.erro) {
                    showMessage("Aviso", "CEP não encontrado na base de dados", "error", null);
                    return;
                }
                _endereco.bairro = response.data.bairro;
                _endereco.uf = response.data.uf;
                _endereco.complemento = response.data.complemento;
                _endereco.logradouro = response.data.logradouro;
                _endereco.cidade = response.data.localidade;
                const erros = validarCampos(_endereco, camposColetaExtra);
                setErrors(erros[0]);
                const endereco = {
                    NumeroCep: _endereco.cep,
                    Bairro: _endereco.bairro,
                    Logradouro: _endereco.logradouro,
                    Cidade: _endereco.cidade,
                    Estado: _endereco.estado,
                    Numero: _endereco.numero,
                    Latitude: "",
                    Longitude: "",
                    EnderecoFormatado: "",
                }
                cep_api.GeoCode(endereco).then(response => {
                    _endereco.latitude = parseFloat(response.data.latitude.replace(",", "."));
                    _endereco.longitude = parseFloat(response.data.longitude.replace(",", "."));
                    setColetaExtra(_endereco);
                }).catch(e => {
                    showMessage("Aviso", e.message, "error");
                })
            }).catch(e => {
                showMessage("Aviso", "CEP não encontrado na base de dados", "error", null);
            });
        }
    }
    //OnChange para o campo de gerador da coleta extraordinaria
    const onChangeGerador = (e, select) => {
        const _coletaExtra = {
            ...coletaExtra,
            [select.name]: e,
            tbGerador_Id: e.value
        }
        const campo = camposColetaExtra.filter(value => value.name === select.name);
        const _errors = validarCampos(_coletaExtra, campo);
        if (_errors[1].length > 0) {
            setErrors({ ...errors, ..._errors[0] });
        } else {
            const newErrors = { ...errors };
            delete newErrors[select.name];
            setErrors(newErrors);
        }
        setColetaExtra(_coletaExtra);
    }

    //Carrega as informações necessarias dos selects
    useEffect(() => {
        //Carrega as modalidades disponiveis para o veiculo selecionado
        rotaColeta_api.GetModalidadesContratosPorVeiculo(ordem.tbVeiculos_Id).then(response => {
            response.data = response.data.map(value => {
                return { value: value.id.toString(), text: value.descricao }
            });
            setModalidades([{ text: "Selecione", value: "" }, ...response.data]);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        })

        //Carrega os geradores disponiveis para a listagem
        gerador_api.GetList().then(response => {
            const options = response.data.map(value => { return { label: value.fantasia, value: value.id } });
            setGeradores(options);
        }).catch(e => showMessage("Aviso", e.message, "error", null))

    }, []);

    return (
        <ModalCustomized title={"Adicionar coleta extraordinária"} isOpen={openModal} toggle={toggleModal} btnClose={() => {
            setColetaExtra(initialStateColetaExtraordinaria(ordem.id))
            toggleModal();
        }} btnAction={"+ Adicionar"} onClickBtnAction={adicionarColetaExtraordinaria} btnActionColor="success">
            <div>
                <Row>
                    <Col md="12" lg="12">
                        <TextField label="* Gerador" type={"select"} searchable name={"tbGeradorSelected"} value={coletaExtra.tbGeradorSelected} onChange={onChangeGerador} options={geradores} invalid={errors.tbGeradorSelected ? true : false} />
                    </Col>
                    <Col md="12" lg="6">
                        <TextField label="* Identificação do local" name={"identificacao"} maxLength={"250"} value={coletaExtra.identificacao} invalid={errors.identificacao ? true : false} onChange={onChangeColetaExtra} />
                    </Col>
                    <Col md="12" lg="6">
                        <TextField label="* Modalidade" type={"select"} name={"tbTipoColeta_Id"} value={coletaExtra.tbTipoColeta_Id} invalid={errors.tbTipoColeta_Id ? true : false} onChange={onChangeModalidade} options={modalidades} />
                    </Col>
                    <Col md="12" lg="6">
                        <TextField label="* Unidade de medida" type={"select"} name={"tbVolumetria_Id"} value={coletaExtra.tbVolumetria_Id} invalid={errors.tbVolumetria_Id ? true : false} onChange={onChangeColetaExtra} options={volumetrias} />
                    </Col>
                    <Col md="12" lg="6">
                        <TextField mask={mascaras.cepMask} label="* CEP" name={"cep"} value={coletaExtra.cep} invalid={errors.cep ? true : false} onChange={onChangeColetaExtra} onBlur={onBlurCep} />
                    </Col>
                    <Col md="12" lg="6">
                        <TextField label="* Logradouro" name={"logradouro"} maxLength={"300"} value={coletaExtra.logradouro} invalid={errors.logradouro ? true : false} onChange={onChangeColetaExtra} />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField label="* Bairro" name={"bairro"} maxLength={"100"} value={coletaExtra.bairro} invalid={errors.bairro ? true : false} onChange={onChangeColetaExtra} />
                    </Col>
                    <Col md="12" lg="2">
                        <TextField mask={mascaras.numeroMask} label="* Numero" name={"numero"} maxLength={"50"} value={coletaExtra.numero} invalid={errors.numero ? true : false} onChange={onChangeColetaExtra} />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField label="* Cidade" name={"cidade"} maxLength={"150"} value={coletaExtra.cidade} invalid={errors.cidade ? true : false} onChange={onChangeColetaExtra} />
                    </Col>
                    <Col md="12" lg="2">
                        <TextField label="* UF" maxLength={"2"} name={"uf"} value={coletaExtra.uf} invalid={errors.uf ? true : false} onChange={onChangeColetaExtra} />
                    </Col>
                    <Col md="12" lg="6">
                        <TextField label="Complemento" maxLength={"200"} name={"complemento"} value={coletaExtra.complemento} invalid={errors.complemento ? true : false} onChange={onChangeColetaExtra} />
                    </Col>
                </Row>
            </div>
        </ModalCustomized>
    )
}